import { render, staticRenderFns } from "./TopOrganizations.vue?vue&type=template&id=0da40ad2&scoped=true&"
import script from "./TopOrganizations.vue?vue&type=script&lang=ts&"
export * from "./TopOrganizations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da40ad2",
  null
  
)

export default component.exports